// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"11d23008","27":"1094e325","66":"96337ea7","161":"1eb1e03b","224":"f0b934dc","907":"e7611aa2","936":"70fb58cf","989":"b9908ad9"}[chunkId] + ".chunk.js";
};